module.exports = __webpack_public_path__ + "img/area1_211021.679fcf64.jpg";